import { render, staticRenderFns } from "./Economies.vue?vue&type=template&id=94998214&"
import script from "./Economies.vue?vue&type=script&lang=js&"
export * from "./Economies.vue?vue&type=script&lang=js&"
import style0 from "./Economies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports